export enum TeachingMethods {
  VirtueltKlasserom = "digital undervisning",
  Nettkurs = "nettkurs",
  Klasserom = "klasserom",
  KombinertUndervisning = "klasserom og digital undervisning",
}
